import type { Url } from '@rossum/api-client';
import {
  type SchemaWithEtag,
  useSchema,
} from '../../../../business/schema/useSchema';
import { toHiddenFieldIds } from '../helpers/toHiddenFieldIds';

const selectHiddenFieldIds = (schema: SchemaWithEtag) =>
  toHiddenFieldIds(schema.content ?? []);

export const useHiddenFieldIds = (schemaUrl: Url, enabled: boolean) =>
  useSchema(enabled ? schemaUrl : undefined, { select: selectHiddenFieldIds });
